import { useMutation, useQueryClient } from '@tanstack/react-query';
import { RfiExternalUpdateDto } from 'src/api/FiretrolApiClient';
import { rfiApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { invalidateFor } from 'src/api/queries/invalidationMap';

/**
 * The external contractor response path: authenticated by the RFI's share
 * token instead of the signed-in user, so it carries no auth context and can
 * only refresh the job's RFI cache when the caller knows the job.
 */
export function useSaveExternalRfi() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      rfiId,
      token,
      request,
    }: {
      rfiId: string;
      token: string | null | undefined;
      jobId?: number;
      request: RfiExternalUpdateDto;
    }) => rfiApiClient.updateExternalRfi(rfiId, token, request),
    meta: { suppressErrorToast: true, errorContext: 'external RFI save' },
    onSettled: (_data, _err, { jobId }) =>
      jobId != null
        ? invalidateFor('rfi.save', qc, { jobId })
        : qc.invalidateQueries({ queryKey: queryKeys.rfis.all() }),
  });
}
